<template>
  <div>
    <Input
      @on-focus="openGroup = true"
      :value="name"
      readonly
      placeholder="请选择"
      clearable
      @on-clear="clear"
    ></Input>

    <Drawer
      :placement="placement"
      :closable="false"
      v-model="openGroup"
      width="450"
      draggable
      class="my-drawer"
    >
      <device-tool @cars="reCars" :isMore="true"/>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["placement"],
  data() {
    return {
      openGroup: false,
      name: "",
      deviceIdList: [],
    };
  },
  methods: {
    reCars(v) {
      var t = [];
      this.deviceIdList = [];
      this.carIdList = [];
      for (let i = 0; i < v.length; i++) {
        t.push(v[i].carNo);
        this.deviceIdList.push(v[i].deviceId);
        this.carIdList.push(v[i].id);
      }
      if (t.length <= 2) {
        this.name = t.join(",");
      } else {
        this.name = t[0] + "等" + t.length + "台车";
      }
      this.$emit("deviceIdList", this.deviceIdList);
      this.$emit("carIdList", this.carIdList);
    },
    clear(){
      this.deviceIdList=[];
      this.carIdList=[];
      this.$emit("deviceIdList", this.deviceIdList);
      this.$emit("carIdList", this.carIdList);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/selectAlotDevice.vue